import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { Spinner } from "lib/components";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { OperatorVariantEdit } from "./operator/features";
import { AdminVariantEdit } from "./admin/features";
import { ProviderVariantEdit } from "./provider/features";

const { userKey } = constant;
const { operator, provider, admin } = userKey;

const VariantEdit = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner />;
    }
    if (role === operator) {
      return <OperatorVariantEdit />;
    }
    if (role === provider) {
      return <ProviderVariantEdit />;
    }
    if (role === admin) {
      return <AdminVariantEdit />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const VariantEditComponent = getComponent(currentUserRole);
  return VariantEditComponent;
};

export default VariantEdit;
